<template lang="pug">
section.sponsor_container.py-5
  .container
    .row
      .col-lg-12.sponsors-title
        h3.title.text-center 特別贊助
        .border-hr
      .col-lg-12.sponsors
        .sponsor(v-for="sponsor in sponsorList", :key="sponsor.id")
          img(v-if="sponsor.photo", :src="sponsor.photo.image")
</template>

<script>
import { getSponsorList } from "@/api/web_content";

export default {
  name: "Sponsor",
  data() {
    return {
      sponsorList: [],
    };
  },
  created() {
    this.getSponsors();
  },
  methods: {
    getSponsors() {
      getSponsorList().then((response) => {
        this.sponsorList = response.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/home/sponsor.scss";
</style>
